import { Stack, Typography } from '@mui/material'
import { Helmet } from 'react-helmet-async'

import SignInComponent from '@/components/auth/SignIn'
import useT from '@/i18n/useT'

function SignIn() {
  const { t } = useT()
  return (
    <>
      <Helmet title={t('signIn.title')} />
      <Stack spacing={4}>
        <Typography component="h2" variant="subtitle1" align="center">
          {t('signIn.subtitle')}
        </Typography>
        <SignInComponent />
      </Stack>
    </>
  )
}

export default SignIn
